export const random = () => {
  const randomDecimal = Math.random();
  const randomNumber = Math.floor(randomDecimal * 10000000000);
  const paddedNumber = randomNumber.toString().padStart(10, "0");
  return paddedNumber;
};
